import { Location, Action } from "history";

import { MessageMap } from "@plex/culture-core";

import { settings } from "config";
import { INotification } from "infrastructure/notification";

export interface ILocalSettings {
  theme: string;
  locale: string;
  isLocaleChanging?: boolean;
}

export interface ISettingsState {
  localSettings: ILocalSettings;
}

export interface IAppTranslationState {
  messages: MessageMap;
  isLoading?: boolean;
  isInitialized?: boolean;
  cacheRefreshTimeInSeconds: number;
  attributes: { [K in typeof settings.localization.messagePrefixes[number]]: ITranslationAttributes };
}

export interface ITranslationAttributes {
  messagePrefix: string;
  lastModified: Date;
}

export interface ITranslationMessages {
  messages: MessageMap;
  loadNewLocale: boolean;
  locale: string;
}

export interface ITranslationMessagesLoadParam {
  loadNewLocale: boolean;
  locale?: string;
}

export interface IAppNotificationState {
  messages: INotification[];
}

export interface ILocationChangeActionData {
  location: Location;
  action: Action;
}

export const getInitialSettingsState = (): ISettingsState => ({
  localSettings: {
    theme: settings.theme,
    locale: ""
  }
});

export const getInitialAppTranslationState = (): IAppTranslationState => ({
  attributes: {},
  cacheRefreshTimeInSeconds: settings.translation.cacheRefreshTimeInSeconds,
  messages: {}
});

export const getInitialAppNotificationState = (): IAppNotificationState => ({
  messages: []
});
